import gql from 'graphql-tag';

const WDT_CLASSROOM_ERRORS_BY_CHARACTERS_QUERY = gql`
  query wdtClassroomErrorsByCharactersReport(
    $where: WdtClassroomErrorsByCharactersReportWhereInput!
    $dateRange: DateRangeInput
  ) {
    wdtClassroomErrorsByCharactersReport(where: $where, dateRange: $dateRange) {
      classroomId
      characterOrder
      characterGroups {
        id
        name
      }
      characterErrors {
        character {
          id
          characterGroupIds
          character
        }
        errors {
          type
          count
        }
      }
    }
  }
`;

export default WDT_CLASSROOM_ERRORS_BY_CHARACTERS_QUERY;
